import { type FC, useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';

import { updateCourseResource } from '@editor2/reducers/editor/editorSlice';
import { type Book } from '@editor2/types/book';
import { tocEditorContainer } from '../styles';
import { useDebouncedDispatch } from '@editor2/hooks/useDebouncedDispatch';

interface Props {
	book: Book;
	courseId: number;
}

const EditorForm: FC<Props> = (props) => {
	const { book, courseId } = props;
	const { name, edition, editorial_notes } = book;

	const debouncedDispatch = useDebouncedDispatch();

	const [fromFields, setFormFields] = useState({ name, edition, editorial_notes });

	useEffect(() => {
		setFormFields({ ...fromFields, name, edition, editorial_notes });
	}, [name, edition, editorial_notes]);

	const handleChange = (value) => {
		setFormFields({ ...fromFields, ...value });
		debouncedDispatch(updateCourseResource({ ...value, courseId }));
	};

	return (
		<Form className={tocEditorContainer}>
			<Form.Group>
				<Form.Control
					size="lg"
					className="courseName"
					value={fromFields.name}
					onChange={(e) => handleChange({ name: e.target.value })}
				/>
			</Form.Group>

			<Form.Group>
				<Form.Label>Edition</Form.Label>
				<Form.Control
					value={fromFields.edition}
					onChange={(e) => handleChange({ edition: e.target.value })}
				/>
			</Form.Group>
		</Form>
	);
};

export default EditorForm;
